import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';
import { Autoplay, Pagination, Navigation } from 'swiper';
import LazyVideo from './LazyVideo'; // Import the LazyVideo component

// Import media
import pay from '../assests/newurban/nu/FindNextClient.mp4';
import pos from '../assests/newurban/nu/3147262-hd_1920_1080_30fps.mp4';
import laptop from '../assests/newurban/nu/5211073-hd_1280_720_30fps.mp4';

const banners = [
  {
    video: pay,
    text: 'Connect With Us For Best Service In Bhagalpur.',
  },
  { video: pos, text: 'All Types Of Plumbing Service Available' },
  { video: laptop, text: 'Home Appliance Service Center Near You' },
];

const Crousel = () => {
  return (
    <div className="w-auto mx-auto bg-gray-200">
      <Swiper
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper w-full opacity-95"
      >
        {banners.map(({ video, text }) => (
          <SwiperSlide
            key={uuidv4()}
            className="relative flex justify-center items-center"
          >
            <Link
              to="/LandingPage"
              className="w-full rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="relative h-64 lg:h-128 w-full sm:h-96 md:h-96">
                <LazyVideo src={video} type="video/mp4" />
                <div className="absolute inset-0 flex justify-center items-center bg-gradient-to-t from-black via-transparent to-black bg-opacity-40">
                  <h1 className="w-1/2 text-center text-white text-lg sm:text-4xl md:text-6xl font-bold leading-relaxed animate-fade-in-up">
                    {text}
                  </h1>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Crousel;
